<template>
    <div class="as-emp_advanced_selector">
        <mock-el-select
            v-if="newSelect"
			slot="reference"
			size="small"
            :multiple="multiple"
			:tag-list="selectListData"
            :placeholder="placeholder"
            :collapseTags="true"
            :clearable="clearable"
			:props="{label: 'viewName', id: 'areaId'}"
			@close="handleTagClose"
            @clear="onClearSelectData"
			@click.native="onShowDialog"
            :wordNumber="wordNumber">
		</mock-el-select>
        <as-selector v-else :clearable="clearable" @clear="onClearSelectData" @click.native="onShowDialog" :label="label" :default="selectViewData"></as-selector>
        <as-shop-dialog-selector
            ref="dialogSelector"
            v-on="$listeners"
            v-bind="$attrs"
            :select-id="singleValue"
            v-model="dialogVisible"
            :multiple="multiple"
            :loading="dialogLoading"
            :group-data="selectorData"
            :sidebar-list="sidebarData"
            :default-checked-keys="defaultCheckedKeys"
            @on-confirm="onConfirm"
            @on-select-item="onSelectItem">
        </as-shop-dialog-selector>
    </div>
</template>

<script>
    import AsSelector from '@/components/selector';
    import MockElSelect from '@/components/mock-el-select';
    import AsShopDialogSelector from '@/components/shop-dialog-selector'
    import AdvancedSelector from '@/components/advanced-selector'
    import UtilsMixins from '@/mixins/utils'
    export default {
        extends: AdvancedSelector,
        name: 'AsShopAdvancedSelector',
        components: {
            AsSelector,
            MockElSelect,
            AsShopDialogSelector,
        },
        props: {
            hasTenant: Boolean,
            filterNode: Function,
            defaultSingleValue: [Number, String],
            multiple: {
                type: Boolean,
                default: true,
            },
            newSelect: {
                type: Boolean,
                default: false
            },
            wordNumber: {
                type: Number,
                default: 30
            }
        },
        mixins: [UtilsMixins],
        computed: {
            selectViewData() {
                const label = 'viewName';
                const count = this.selectListData ? this.selectListData.length : 0;
                if (!count) return this.defaultSelectData;
                const appendFixLabel = count > 1 ? `+ ${count - 1}` : '';
                const name = `${this.selectListData[0][label]}${appendFixLabel}`;
                return {
                    name,
                }
            },
            singleValue() {
                const selectItem = this.selectListData ? this.selectListData[0] : null;
                return selectItem ? selectItem.id : this.defaultSingleValue;
            },
        },
        methods: {
            handleTagClose(index) {
                this.selectListData.splice(index, 1);
                this.triggerEvent(this.selectListData);
            },
            onClearSelectData() {
                this.clear();
            },
            loadDataCallback(listData) {
                let { children: contentData, name, id } = listData;
                const tenantShopData = {
                    name,
                    id,
                    softgenre: 0,
                    viewName: name,
                    areaId: 999999,
                }
                const tenantGroupData = {
                    name: '总部',
                    viewName: '总部',
                    id: 999999,
                    children: [ tenantShopData ]
                }
                contentData.filter(item => item.children && item.children.length).forEach(areaData => {
                    const { name, children } = areaData;
                    areaData.viewName = name;
                    areaData.children = children.map(shopData => {
                        shopData.viewName = this.getShopNameByData(shopData)
                        return shopData;
                    })
                    if (this.filterNode) {
                        areaData.children = areaData.children.filter(item => this.filterNode(item));
                    }
                })
                if (this.filterNode) {
                    // 如果过滤节点的方法存在，则再次过滤一下
                    contentData = contentData.filter(item => item.children.length > 0);
                }
                contentData = contentData.sort((a, b) => { return (b.id - a.id) });
                const otherIndex = contentData.findIndex(item => item.name === '全部');
                if (otherIndex !== -1) {
                    contentData[otherIndex].viewName = contentData.length > 1 ? '其他' : '门店';
                }
                if (this.hasTenant) {
                    const hasTenant = contentData.some(item => item.id === tenantGroupData.id);
                    if (!hasTenant) {
                        contentData.unshift(tenantGroupData);
                    }
                }
                this.loadSelectorData = contentData;
                this.loadSidebarData = contentData;
                this.dialogLoading = false;
            },
        },
    }
</script>
<style lang="scss">
.as-emp_advanced_selector {
    display: inline-flex;
}
</style>